// For more information on data-driven styles, see
// https://www.mapbox.com/help/gl-dds-ref/
export const pointStyle = {
  id: 'points',
  type: 'circle',
  'source-layer': 'langsNY_06242020-2lztil',
  paint: {
    // https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
    'circle-color': [
      'match',
      ['get', 'Region'],
      'Eastern Europe',
      '#fbb03b',
      'Northern Europe',
      '#fbb03b',
      'Southern Europe',
      '#fbb03b',
      'Western Europe',
      '#fbb03b',
      'Central Asia',
      '#223b53',
      'Eastern Asia',
      '#223b53',
      'Southeastern Asia',
      '#223b53',
      'Southern Asia',
      '#223b53',
      'Western Asia',
      '#223b53',
      'Eastern Africa',
      '#e55e53',
      'Middle Africa',
      '#e55e53',
      'Northern Africa',
      '#e55e53',
      'Southern Africa',
      '#e55e53',
      'Western Africa',
      '#e55e53',
      'Caribbean',
      '#3bb2d0',
      'Central America',
      '#3bb2d0',
      'Northern America',
      '#3bb2d0',
      'South America',
      '#3bb2d0',
      'Southern America',
      '#3bb2d0',
      'Melanesia',
      'tan',
      'Micronesia',
      'tan',
      'Polynesia',
      'tan',
      'Oceania',
      'tan',
      '#ccc',
    ],
  },
}
